import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setScrolled(true);
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl shadow-lg">
      <div className="max-w-[1400px] mx-auto px-8 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <div className="text-2xl font-bold text-[#0A1628]">UnityCore</div>
          <div className="h-px w-12 bg-[#D4AF37] ml-4"></div>
        </Link>
        
        <div className="flex items-center gap-12">
          <Link to="/" className="text-sm font-light tracking-wide text-[#0A1628] transition-all hover:text-[#D4AF37]">О нас</Link>
          <Link to="/financial-consulting" className="text-sm font-light tracking-wide text-[#0A1628] transition-all hover:text-[#D4AF37]">Финансы</Link>
          <Link to="/management-consulting" className="text-sm font-light tracking-wide text-[#0A1628] transition-all hover:text-[#D4AF37]">Управление</Link>
          <Link to="/geography" className="text-sm font-light tracking-wide text-[#0A1628] transition-all hover:text-[#D4AF37]">География</Link>
          <Link to="/contacts" className="text-sm font-light tracking-wide text-[#0A1628] transition-all hover:text-[#D4AF37]">Контакты</Link>
        </div>

        <div className="flex items-center gap-4">
          <button className="px-4 py-2 rounded-full text-sm font-light text-[#0A1628]">
            RU | EN | TR
          </button>
          <Link to="/contacts" className="px-8 py-3 rounded-full bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-[#0A1628] text-sm font-medium whitespace-nowrap hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
            Консультация
          </Link>
        </div>
      </div>
    </nav>
  );
}
